// import React, { useState } from 'react';
// import * as XLSX from 'xlsx';
// import { saveAs } from 'file-saver';
// import { getAssessmentData } from '../apis/services/csaApi';

// const ExcelProcessor = () => {
//   const [userName, setUserName] = useState('admin');
//   const [assessmentId, setAssessmentId] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [progress, setProgress] = useState('');
//   const [error, setError] = useState('');

//   const processExcel = async () => {
//     try {
//       setLoading(true);
//       setError('');
//       setProgress('Initializing...');

//       // Step 1: Load the template
//       setProgress('Loading template...');
//       const templatePath = '/assets/Assessment Report.xlsx';
//       const templateResponse = await fetch(templatePath);
//       const templateArrayBuffer = await templateResponse.arrayBuffer();
      
//       // Step 2: Parse the template
//       setProgress('Parsing template...');
//       const workbook = XLSX.read(templateArrayBuffer, { cellStyles: true });
      
//       // Step 3: Fetch data from API
//       setProgress('Fetching data from server...');
//       const response = await getAssessmentData(userName, assessmentId);
      
//       if (!response.success) {
//         throw new Error(response.message || 'Failed to fetch data');
//       }
      
//       // Step 4: Update worksheets with data
//       setProgress('Updating worksheets...');
//       await updateWorksheets(workbook, response.data);
      
//       // Step 5: Generate the output file
//       setProgress('Generating final report...');
//       const excelBuffer = XLSX.write(workbook, {
//         bookType: 'xlsx',
//         type: 'array',
//         cellStyles: true
//       });
      
//       // Step 6: Download the file
//       saveAs(
//         new Blob([excelBuffer], { type: 'application/octet-stream' }),
//         `Assessment_Report_${userName}_${assessmentId}.xlsx`
//       );
      
//       setProgress('Download complete!');
//     } catch (err) {
//       console.error('Error processing Excel:', err);
//       setError(`Error: ${err.message}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const updateWorksheets = async (workbook, data) => {
//     // Get all sheet names
//     const sheetNames = workbook.SheetNames;
    
//     // Define the mapping between DataTables and sheets
//     const sheetMapping = {
//       // English sheets
//       'Segmentation_Opportunity': { dataKey: 'table', startRow: 1 },
//       'RGM_Opportunity': { dataKey: 'table1', startRow: 1 },
//       'RTM_Opportunity': { dataKey: 'table2', startRow: 1 },
//       'P.A.C.E_Opportunity': { dataKey: 'table3', startRow: 1 },
//       'EXECUTION_Opportunity': { dataKey: 'table4', startRow: 1 },
//       'CVC_Opportunity': { dataKey: 'table5', startRow: 1 },
//       'Report': { dataKey: 'table6', startRow: 1 },
//       'Score': { dataKey: 'table7', startRow: 1 },
      
//       // CN sheets
//       'SEGMENTATION Opportunity - CN': { dataKey: 'table8', startRow: 1 },
//       'RGM Opportunity - CN': { dataKey: 'table9', startRow: 1 },
//       'RTM Opportunity - CN': { dataKey: 'table10', startRow: 1 },
//       'P.A.C.E Opportunity - CN': { dataKey: 'table11', startRow: 1 },
//       'EXECUTION Opportunity - CN': { dataKey: 'table12', startRow: 1 },
//       'CVC Opportunity - CN': { dataKey: 'table13', startRow: 1 },
//       'REPORT_CN': { dataKey: 'table14', startRow: 1 },
//       'Score - CN': { dataKey: 'table15', startRow: 1 }
//     };

//     // Process each sheet
//     for (const sheetName of sheetNames) {
//       const mapping = sheetMapping[sheetName];
//       if (!mapping || !data[mapping.dataKey]) continue;
      
//       const worksheet = workbook.Sheets[sheetName];
//       const tableData = data[mapping.dataKey];
      
//       // Get the original range to preserve formatting
//       const range = XLSX.utils.decode_range(worksheet['!ref']);
      
//       // Store original styles by column
//       const columnStyles = {};
//       for (let c = range.s.c; c <= range.e.c; c++) {
//         const headerCell = XLSX.utils.encode_cell({ r: mapping.startRow - 1, c });
//         if (worksheet[headerCell] && worksheet[headerCell].s) {
//           columnStyles[c] = worksheet[headerCell].s;
//         }
//       }
      
//       // Clear existing data below headers (if needed)
//       if (range.e.r > mapping.startRow) {
//         const clearRange = XLSX.utils.encode_range({
//           s: { r: mapping.startRow, c: range.s.c },
//           e: { r: range.e.r, c: range.e.c }
//         });
//         const clearCells = XLSX.utils.decode_range(clearRange);
        
//         for (let r = clearCells.s.r; r <= clearCells.e.r; r++) {
//           for (let c = clearCells.s.c; c <= clearCells.e.c; c++) {
//             const cellAddress = XLSX.utils.encode_cell({ r, c });
//             delete worksheet[cellAddress];
//           }
//         }
//       }
      
//       // Write headers if they exist
//       if (tableData.columns && tableData.columns.length > 0) {
//         tableData.columns.forEach((col, colIndex) => {
//           const cellAddress = XLSX.utils.encode_cell({ r: mapping.startRow - 1, c: colIndex });
//           if (!worksheet[cellAddress]) worksheet[cellAddress] = {};
//           worksheet[cellAddress].v = col;
//           worksheet[cellAddress].t = 's';
          
//           // Apply column style if available
//           if (columnStyles[colIndex]) {
//             worksheet[cellAddress].s = columnStyles[colIndex];
//           }
//         });
//       }
      
//       // Prepare data for bulk insert
//       const sheetData = tableData.rows.map(row => {
//         return tableData.columns.map(col => {
//           // Map the column names to your data structure
//           switch(col) {
//             case 'SN': return row.sn;
//             case 'Questions': return row.questions;
//             case 'GroupName': return row.groupName;
//             case 'Enablers': return row.enablers;
//             case 'Current': return row.current;
//             case 'Desired': return row.desired;
//             case 'Remark': return row.remark;
//             default: return row[col.toLowerCase()] || '';
//           }
//         });
//       });
      
//       // Insert data in bulk
//       if (sheetData.length > 0) {
//         XLSX.utils.sheet_add_aoa(worksheet, sheetData, {
//           origin: XLSX.utils.encode_cell({ r: mapping.startRow, c: 0 })
//         });
        
//         // Apply styles to all data cells
//         for (let r = 0; r < sheetData.length; r++) {
//           for (let c = 0; c < sheetData[0].length; c++) {
//             const cellAddress = XLSX.utils.encode_cell({ 
//               r: mapping.startRow + r, 
//               c 
//             });
            
//             if (!worksheet[cellAddress]) continue;
            
//             // Apply column style if available
//             if (columnStyles[c]) {
//               worksheet[cellAddress].s = columnStyles[c];
//             }
            
//             // Special formatting for numeric columns
//             if (tableData.columns[c] === 'Current' || tableData.columns[c] === 'Desired') {
//               worksheet[cellAddress].s = {
//                 ...(worksheet[cellAddress].s || {}),
//                 numFmt: '0.00'
//               };
//             }
//           }
//         }
//       }
      
//       // Update the sheet range
//       const newMaxRow = mapping.startRow + sheetData.length;
//       if (newMaxRow > range.e.r) {
//         range.e.r = newMaxRow;
//       }
//       worksheet['!ref'] = XLSX.utils.encode_range(range);
//     }
//   };

//   return (
//     <div className="wrapper mt-20">
//       <div className="card">
//         <div className="card-header">
//           <h2>Assessment Report Generator</h2>
//         </div>
//         <div className="card-body">
//           <div className="row mb-3">
//             <div className="col-md-6">
//               <label className="form-label">Username</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 value={userName}
//                 onChange={(e) => setUserName(e.target.value)}
//               />
//             </div>
//             <div className="col-md-6">
//               <label className="form-label">Assessment ID</label>
//               <input
//                 type="number"
//                 className="form-control"
//                 value={assessmentId}
//                 onChange={(e) => setAssessmentId(e.target.value)}
//               />
//             </div>
//           </div>
          
//           <button
//             className="btn btn-primary"
//             onClick={processExcel}
//             disabled={loading || !userName || !assessmentId}
//           >
//             {loading ? 'Processing...' : 'Generate Report'}
//           </button>
          
//           {loading && (
//             <div className="mt-3">
//               <div className="progress">
//                 <div
//                   className="progress-bar progress-bar-striped progress-bar-animated"
//                   role="progressbar"
//                   style={{ width: '100%' }}
//                 ></div>
//               </div>
//               <p className="text-muted mt-2">{progress}</p>
//             </div>
//           )}
          
//           {error && (
//             <div className="alert alert-danger mt-3">
//               {error}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ExcelProcessor;

import React, { useState } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { getAssessmentData } from '../apis/services/csaApi';

const ExcelProcessor = () => {
  const [userName, setUserName] = useState('admin');
  const [assessmentId, setAssessmentId] = useState(1);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState('');
  const [error, setError] = useState('');

  const processExcel = async () => {
    try {
      setLoading(true);
      setError('');
      setProgress('Initializing...');

      // Step 1: Load the template
      setProgress('Loading template...');
      const templatePath = '/assets/Assessment Report.xlsx';
      const templateResponse = await fetch(templatePath);
      const templateArrayBuffer = await templateResponse.arrayBuffer();
      
      // Step 2: Parse the template with ExcelJS
      setProgress('Parsing template...');
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(templateArrayBuffer);
      
      // Step 3: Fetch data from API
      setProgress('Fetching data from server...');
      const response = await getAssessmentData(userName, assessmentId);
      
      if (!response.success) {
        throw new Error(response.message || 'Failed to fetch data');
      }
      
      // Step 4: Update worksheets with data
      setProgress('Updating worksheets...');
      await updateWorksheets(workbook, response.data);
      
      // Step 5: Generate the output file
      setProgress('Generating final report...');
      const excelBuffer = await workbook.xlsx.writeBuffer();
      
      // Step 6: Download the file
      saveAs(
        new Blob([excelBuffer], { type: 'application/octet-stream' }),
        `Assessment_Report_${userName}_${assessmentId}.xlsx`
      );
      
      setProgress('Download complete!');
    } catch (err) {
      console.error('Error processing Excel:', err);
      setError(`Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const updateWorksheets = async (workbook, data) => {
    // Define the mapping between DataTables and sheets
    const sheetMapping = {
      // English sheets
      'Segmentation_Opportunity': { dataKey: 'table', startRow: 2 },
      'RGM_Opportunity': { dataKey: 'table1', startRow: 2 },
      'RTM_Opportunity': { dataKey: 'table2', startRow: 2 },
      'P.A.C.E_Opportunity': { dataKey: 'table3', startRow: 2 },
      'EXECUTION_Opportunity': { dataKey: 'table4', startRow: 2 },
      'CVC_Opportunity': { dataKey: 'table5', startRow: 2 },
      'Report': { dataKey: 'table6', startRow: 2 },
      'Score': { dataKey: 'table7', startRow: 2 },
      
      // CN sheets
      'SEGMENTATION Opportunity - CN': { dataKey: 'table8', startRow: 2 },
      'RGM Opportunity - CN': { dataKey: 'table9', startRow: 2 },
      'RTM Opportunity - CN': { dataKey: 'table10', startRow: 2 },
      'P.A.C.E Opportunity - CN': { dataKey: 'table11', startRow: 2 },
      'EXECUTION Opportunity - CN': { dataKey: 'table12', startRow: 2 },
      'CVC Opportunity - CN': { dataKey: 'table13', startRow: 2 },
      'REPORT_CN': { dataKey: 'table14', startRow: 2 },
      'Score - CN': { dataKey: 'table15', startRow: 2 }
    };

    // Process each worksheet
    workbook.eachSheet((worksheet, sheetId) => {
      const mapping = sheetMapping[worksheet.name];
      if (!mapping || !data[mapping.dataKey]) return;

      const tableData = data[mapping.dataKey];
      
      // Clear existing data rows (preserving headers and formatting)
      const rowCount = worksheet.rowCount;
      if (rowCount > mapping.startRow) {
        worksheet.spliceRows(mapping.startRow, rowCount - mapping.startRow + 1);
      }
      
      // Get header styles for replication
      const headerStyles = {};
      const headerRow = worksheet.getRow(mapping.startRow - 1);
      headerRow.eachCell((cell, colNumber) => {
        headerStyles[colNumber] = {
          font: { ...cell.font },
          fill: { ...cell.fill },
          border: { ...cell.border },
          alignment: { ...cell.alignment },
          numFmt: cell.numFmt
        };
      });
      
      // Add new data rows
      tableData.rows.forEach((row, rowIndex) => {
        const newRow = worksheet.getRow(mapping.startRow + rowIndex);
        
        tableData.columns.forEach((col, colIndex) => {
          const cell = newRow.getCell(colIndex + 1);
          
          // Map the column names to your data structure
          let cellValue;
          switch(col) {
            case 'SN': cellValue = row.sn; break;
            case 'Questions': cellValue = row.questions; break;
            case 'GroupName': cellValue = row.groupName; break;
            case 'Enablers': cellValue = row.enablers; break;
            case 'Current': cellValue = row.current; break;
            case 'Desired': cellValue = row.desired; break;
            case 'Remark': cellValue = row.remark; break;
            default: cellValue = row[col.toLowerCase()] || '';
          }
          
          cell.value = cellValue;
          
          // Apply formatting from header
          if (headerStyles[colIndex + 1]) {
            cell.font = headerStyles[colIndex + 1].font;
            cell.fill = headerStyles[colIndex + 1].fill;
            cell.border = headerStyles[colIndex + 1].border;
            cell.alignment = headerStyles[colIndex + 1].alignment;
            
            // Special number formatting for numeric columns
            if (col === 'Current' || col === 'Desired') {
              cell.numFmt = '0.00';
            } else {
              cell.numFmt = headerStyles[colIndex + 1].numFmt;
            }
          }
        });
      });
      
      // Auto-fit columns if needed
      worksheet.columns.forEach(column => {
        if (column.values && column.values.length > 0) {
          let maxLength = 0;
          column.values.forEach(value => {
            if (value != null) {
              const length = value.toString().length;
              maxLength = Math.max(maxLength, length);
            }
          });
          column.width = Math.min(Math.max(maxLength + 2, 10), 50);
        }
      });
    });
  };

  return (
    <div className="wrapper mt-20">
      <div className="card">
        <div className="card-header">
          <h2>Assessment Report Generator</h2>
        </div>
        <div className="card-body">
          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label">Username</label>
              <input
                type="text"
                className="form-control"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Assessment ID</label>
              <input
                type="number"
                className="form-control"
                value={assessmentId}
                onChange={(e) => setAssessmentId(Number(e.target.value))}
              />
            </div>
          </div>
          
          <button
            className="btn btn-primary"
            onClick={processExcel}
            disabled={loading || !userName || !assessmentId}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Processing...
              </>
            ) : 'Generate Report'}
          </button>
          
          {loading && (
            <div className="mt-3">
              <div className="progress">
                <div
                  className="progress-bar progress-bar-striped progress-bar-animated"
                  role="progressbar"
                  style={{ width: '100%' }}
                ></div>
              </div>
              <p className="text-muted mt-2">{progress}</p>
            </div>
          )}
          
          {error && (
            <div className="alert alert-danger mt-3">
              {error}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExcelProcessor;